/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx";

type ProvenExpertSealStandardProps = {
  sx?: SxProps<Theme>;
};

const ProvenExpertSealStandard = ({ sx }: ProvenExpertSealStandardProps) => {
  return (
    <a
      href="https://www.provenexpert.com/legalbird/?utm_source=Widget&amp;utm_medium=Widget&amp;utm_campaign=Widget"
      title="Erfahrungen &amp; Bewertungen zu Legalbird anzeigen"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Box
        component={"img"}
        src="https://images.provenexpert.com/ca/70/17a7e460654ab3270025208dddab/widget_square_200_de_0.png"
        sx={mergeSx({ display: "block" }, sx)}
        alt="Erfahrungen &amp; Bewertungen zu Legalbird"
        width={200}
        height={200}
      />
    </a>
  );
};

export default ProvenExpertSealStandard;
